import React from 'react';
import './NavBar.css';

const NavBar = () => {
  return (
    <nav className="navbar">
        <div className="navbar-inner">
            <h1 className="navbar-name">Alice Rey</h1>
            <h2 className="navbar-title">Software / Data / AI Engineer</h2>
        </div>
    </nav>
  );
};
export default NavBar;